// One supported merge-field set for Compose and Template editing (all resolved by the backend).
export const MERGE_GROUPS = [
  ["Candidate", [
    ["candidate_first_name", "Candidate First Name"],
    ["candidate_full_name", "Candidate Full Name"],
    ["candidate_email", "Candidate Email"],
    ["candidate_program", "Candidate Program"],
    ["candidate_stage", "Candidate Stage"],
    ["candidate_portal_link", "Candidate Portal Link"],
    ["assigned_recruiter_name", "Assigned Recruiter Name"],
  ]],
  ["Sender", [
    ["sender_full_name", "Sender Full Name"],
    ["sender_title", "Sender Title"],
    ["sender_credentials", "Sender Credentials"],
    ["sender_email", "Sender Email"],
    ["sender_company_or_team", "Sender Company / Team"],
    ["sender_manager_name", "Sender Manager Name"],
    ["sender_markets", "Sender Markets"],
    ["sender_mobile_phone", "Sender Mobile Phone"],
    ["sender_recruiting_direct_phone", "Sender Direct Phone"],
    ["sender_office_main_phone", "Sender Office Main Phone"],
    ["sender_office_address", "Sender Office Address"],
    ["sender_calendar_link", "Sender Scheduling Link"],
    ["sender_linkedin_url", "Sender LinkedIn"],
    ["sender_signature", "Sender Signature"],
  ]],
];

const LEGACY = {
  FirstName: "Candidate First Name", LastName: "Candidate Last Name", FullName: "Candidate Full Name",
  RecruiterName: "Sender Full Name", RecruiterEmail: "Sender Email", AgencyName: "Agency Name",
  CandidateType: "Candidate Program", CurrentStage: "Candidate Stage", JobTitle: "Job Title",
  appointment_date: "Appointment Date", appointment_time: "Appointment Time", appointment_link: "Appointment Link",
  document_name: "Document Name", document_due_date: "Document Due Date",
};

export const FIELD_LABELS = Object.fromEntries([...MERGE_GROUPS.flatMap(([, f]) => f), ...Object.entries(LEGACY)]);

export const fieldLabel = (key) => FIELD_LABELS[key] || key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
